"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tabbable = require("tabbable");
var _useWindowWidth = _interopRequireDefault(require("../../utils/use-window-width"));
var _excluded = ["children", "disableBodyScrollWhenActive", "enabled", "wrapperDivClassName", "wrapWithDiv"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Traps keyboard focus in a given element. When opening a dynamically created element,
 * for accessibility we may want to trap keyboard focus in the new element.
 * This is advised for any kind of modal, and may be
 * appropriate for tooltips or components that visually obscure other parts of the UI.
 *
 * FocusTrap is built into the <a href="/components/modal-provider">ModalProvider</a> already.
 *
 * In addition to trapping keyboard focus, FocusTrap can optionally prevent the
 * body from scrolling via the `disableBodyScrollWhenActive` prop.
 * This option is in use in the ModalProvider.
 */

var FocusTrap = function FocusTrap(_ref) {
  var children = _ref.children,
    _ref$disableBodyScrol = _ref.disableBodyScrollWhenActive,
    disableBodyScrollWhenActive = _ref$disableBodyScrol === void 0 ? true : _ref$disableBodyScrol,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    _ref$wrapperDivClassN = _ref.wrapperDivClassName,
    wrapperDivClassName = _ref$wrapperDivClassN === void 0 ? '' : _ref$wrapperDivClassN,
    _ref$wrapWithDiv = _ref.wrapWithDiv,
    wrapWithDiv = _ref$wrapWithDiv === void 0 ? false : _ref$wrapWithDiv,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var rootNodeRef = (0, _react.useRef)();
  var windowWidth = (0, _useWindowWidth["default"])();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    scrollbarOffset = _useState2[0],
    setScrollbarOffset = _useState2[1];
  var handleKeydown = function handleKeydown(e) {
    var _e$key;
    if (!enabled) {
      return;
    }
    var isTabPressed = (e === null || e === void 0 || (_e$key = e.key) === null || _e$key === void 0 ? void 0 : _e$key.toLowerCase()) === 'tab';
    if (!isTabPressed) {
      return;
    }
    var trapElements = (0, _tabbable.tabbable)(rootNodeRef.current);
    var firstTrapElement = trapElements[0];
    var lastTrapElement = trapElements[trapElements.length - 1];
    if (document.activeElement === lastTrapElement && !e.shiftKey) {
      // loop them around if they're focused on the last element in the trap
      e.preventDefault();
      firstTrapElement.focus();
    }
    if (document.activeElement === firstTrapElement && e.shiftKey) {
      // user is shift-tabbing from the first element, loop them onto the last element
      e.preventDefault();
      lastTrapElement.focus();
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeydown);
    return function () {
      document.removeEventListener('keydown', handleKeydown);
    };
    // the callback passed to the event handler apparently does not use the closure
    // of the enabled prop, we let React re-create this function as the enabled
    // prop changes by passing it as a dependency.
  }, [enabled]);
  (0, _react.useEffect)(function () {
    setScrollbarOffset(windowWidth - document.body.clientWidth);
  }, [windowWidth]);
  var combinedProps = _objectSpread({
    ref: rootNodeRef
  }, otherProps);
  var child = enabled && !wrapWithDiv ? /*#__PURE__*/(0, _react.cloneElement)(_react.Children.only(children), combinedProps) : children;

  // if there's a scrollbar present, layout will shift slightly when setting
  // body overflow to hidden, so we first calculate any needed offset
  var scrollStyle = disableBodyScrollWhenActive && enabled && typeof scrollbarOffset === 'number' ? /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "body { overflow: hidden !important; padding-right: ".concat(scrollbarOffset, "px }")
    }
  }) : null;
  return wrapWithDiv ? /*#__PURE__*/_react["default"].createElement("div", _extends({}, combinedProps, {
    className: wrapperDivClassName
  }), scrollStyle, child) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, scrollStyle, child);
};
FocusTrap.displayName = 'FocusTrap';
FocusTrap.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If not using the 'wrapWithDiv' option, this needs to be a single child element or React
   * Component for FocusTrap to wrap so that focus events are delegated correctly.
   * Make sure your child forwards the ref being passed by this component
   * if not using the wrapWithDiv option.
   */
  children: _propTypes["default"].any,
  /**
   * For use cases such as a modal where the body should not scroll, set this option to true.
   */
  disableBodyScrollWhenActive: _propTypes["default"].bool,
  /**
   * Flag indicating whether FocusTrap should be active (for use cases in which it is always mounted)
   */
  enabled: _propTypes["default"].bool,
  /**
   * If using the `wrapWithDiv` option, you may need to pass styling to the div that is created.
   * Pass a css className with this prop.
   */
  wrapperDivClassName: _propTypes["default"].string,
  /**
   * Flag indicating whether to wrap the children of this component with a div (including focus
   * management props). This is useful when the child of this component ignores extra props.
   */
  wrapWithDiv: _propTypes["default"].bool
} : {};
var _default = exports["default"] = FocusTrap;